import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./common/global.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
